<div class="m-3">

  <div class="my-4">
    {{this.strings.getString('SelectTargetConfigurations')}}
  </div>

  <check-box *ngFor="let conf of confItems" [triState]="false" [view]="conf" (onValueChange)="onConfChange($event)">
  </check-box>

  <div class="mt-2 text-right">
    <button class="btn btn-primary" [style.width.px]="'100'" (click)="copyValues()" type="button">Yes</button>
    <button class="btn btn-primary ml-2" [style.width.px]="'100'" (click)="onClose.emit($event)" type="button">No</button>
  </div>
</div>
